import { createContext, useCallback, useContext, useEffect, useState } from "react";

const ThemeContext = createContext({ theme: "light", setTheme: () => {}, applyTheme: () => {} });
const KEY = "studio_theme";

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => {
    const saved = localStorage.getItem(KEY);
    if (saved === "light" || saved === "dark") return saved;
    // First visit: follow the device until the workspace default or the toggle says otherwise.
    return window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  });

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
  }, [theme]);

  // Explicit choice — remembered on this device.
  const setTheme = useCallback((next) => {
    localStorage.setItem(KEY, next);
    setThemeState(next);
  }, []);

  // Workspace default — applied without claiming it was the person's own choice.
  const applyTheme = useCallback((next) => setThemeState(next), []);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, applyTheme }}>{children}</ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
